<script>
  import { route, navigate } from '../../lib/stores/router.svelte.js';
  import { groupsState } from '../../lib/stores/groups.svelte.js';
  import { isUserAnonymous } from '../../lib/stores/auth.svelte.js';
  import GroupPicker from './GroupPicker.svelte';

  const tabs = [
    { key: 'search', label: 'Search Cards' },
    { key: 'binders', label: 'Binders' },
    { key: 'groups', label: 'Groups' },
    { key: 'wants', label: 'Wants' },
  ];

  function handleTabClick(key) {
    if (route.view !== key) {
      navigate(key);
    }
  }
</script>

<header class="tab-bar">
  <div class="tab-bar-inner">
    <nav class="tabs">
      {#each tabs as tab (tab.key)}
        {#if tab.key === 'search' || (!isUserAnonymous() && groupsState.userGroups.length > 0)}
          <button
            class="tab"
            class:active={route.view === tab.key}
            onclick={() => handleTabClick(tab.key)}
          >
            {tab.label}
          </button>
        {/if}
      {/each}
    </nav>

    <GroupPicker />
  </div>
</header>

<style>
  .tab-bar {
    position: sticky;
    top: 0;
    z-index: 50;
    background: var(--color-bar-bg);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-bottom: 1px solid var(--color-border);
  }

  .tab-bar-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 56px;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 var(--space-xl);
    padding-left: 60px; /* leave room for sidebar hamburger */
  }

  .tabs {
    display: flex;
    gap: var(--space-xs);
  }

  .tab {
    all: unset;
    cursor: pointer;
    color: var(--color-text-tertiary);
    padding: var(--space-sm) var(--space-md);
    font-size: 14px;
    font-weight: 400;
    font-family: var(--font-sans);
    border-bottom: 2px solid transparent;
    margin-bottom: -1px;
    transition:
      color 0.15s,
      border-color 0.15s;
  }

  .tab:hover {
    color: var(--color-text-secondary);
  }

  .tab.active {
    color: var(--color-text);
    font-weight: 600;
    border-bottom-color: var(--color-text);
  }

  @media (max-width: 600px) {
    .tab-bar-inner {
      padding: 0 var(--space-md);
      padding-left: 52px;
    }

    .tab {
      font-size: 13px;
      padding: var(--space-sm) 10px;
    }
  }
</style>
